<app-offcanvas-base [returnUrl]="returnUrl()">
  <ng-container title>
    <app-offcanvas-header-btn title="Upgrade Plan"></app-offcanvas-header-btn>
  </ng-container>
  <ng-container body>
    @if (availableUpgrade; as packageDetail) {
      <div class="stashio-plus">
        <p class="text-gray-500 mb-0">
          Subscribe to <span class="fw-medium">{{ packageDetail?.name }}</span>
        </p>
        <div class="amount">
          @if (isYearly()) {
            {{ packageDetail?.yearly_cost | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator }}
            <span class="text-md text-gray-500 fw-normal">per year</span>
          } @else {
            {{ packageDetail?.monthly_cost | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator }}
            <span class="text-md text-gray-500 fw-normal">per month</span>
          }
        </div>
        <button
          class="btn-reset text-secondary btn-link"
          (click)="helpDesk()">
          Custom Plan Enquiry<span class="text-decoration-none"><i class="iconoir-arrow-right ms-1"></i></span>
        </button>
      </div>
      <div class="plan">
        <div class="card shadow border-dark border-2">
          <div class="card-body">
            <div class="row">
              <div class="col">
                <div class="card-title mb-0 fw-semibold">{{ packageDetail?.name }}</div>
              </div>
              <div class="col-auto">
                <div class="h4 mb-0">
                  @if (isYearly()) {
                    {{ packageDetail?.yearly_cost | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator }}
                  } @else {
                    {{ packageDetail?.monthly_cost | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator }}
                  }
                </div>
              </div>
            </div>
            <hr />
            <p class="text-muted mb-2">What's included</p>
            <ul class="icon-bullet-list text-sm">
              @for (item of packageDetail.features; track $index) {
                <li><i class="iconoir-check-circle"></i> {{ item }}</li>
              }
            </ul>
            <!-- TEMP REMOVE -->
            <!--
            <app-billing-switch
              class="mt-3 d-block"
              (frequencyChange)="handleFrequencyChange($event)"
              [frequency]="billingFrequency()"
              [package]="availableUpgrade"
            [isDisabled]="currentYearly()"></app-billing-switch>
            -->
            <app-payment-method
              [paymentMethod]="paymentMethod()"
              [payfastToken]="payfastToken()"></app-payment-method>
          </div>
        </div>
      </div>
      <div class="small text-muted mt-3">
        Your subscription will renew automatically every
        @if (isYearly()) {
          year.
        } @else {
          month.
        }
        You can cancel anytime.
      </div>
      @if (isYearly()) {
        <div class="row justify-content-between mt-3 text-success text-lg">
          <div class="col-auto">You save</div>
          <div class="col-auto">{{ savings | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator }}</div>
        </div>
      }
      <hr />
      <div class="row justify-content-between text-dark fw-medium text-lg mb-3">
        <div class="col-auto">Total due today</div>
        <div class="col-auto">
          @if (isYearly()) {
            {{ proRataYearly | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator }}
          } @else {
            {{ proRataMonthly | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator }}
          }
        </div>
      </div>
      <div class="row offcanvas-buttons">
        <div class="col-12 col-sm-auto ms-sm-auto">
          <button
            (click)="onUpgradePackage()"
            class="btn btn-primary"
            type="button">
            Confirm
          </button>
        </div>
      </div>
    } @else {
      <app-loader class="my-5"></app-loader>
    }
  </ng-container>
</app-offcanvas-base>
